// extracted by mini-css-extract-plugin
module.exports = {"packingListContainer":"ServiceAct_packingListContainer__1qa0k","packingList":"ServiceAct_packingList__KZLrs","templateContent":"ServiceAct_templateContent__3PqTs"};